import { Capacitor } from '@capacitor/core'
import Button from '../../ui/primitives/Button'

export default function UpdateAppButton() {
  const isIOS = Capacitor.getPlatform() === 'ios'

  function openStore() {
    window.open(isIOS ? process.env.REACT_APP_IOS_URL : process.env.REACT_APP_ANDROID_URL, '_blank')
  }

  return <Button onClick={openStore}>{isIOS ? 'Update on App Store' : 'Update on Play Store'}</Button>
}
